var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.676 77.339C154.676 120.05 120.051 154.676 77.339 154.676C34.625 154.676 0 120.05 0 77.339C0 34.625 34.625 0 77.339 0C120.051 0 154.676 34.625 154.676 77.339Z",
    fill: "#F0592B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7281 58.373C75.7281 58.373 74.7711 88.4301 69.3741 89.0541C63.9781 89.6771 56.186 60.6321 56.186 60.6321C56.186 60.6321 45.7671 21.611 62.6321 20.439C79.4971 19.268 75.7281 58.373 75.7281 58.373Z",
    fill: "#8A603C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.026 58.684C73.026 58.684 72.333 80.426 68.429 80.876C64.526 81.327 58.891 60.318 58.891 60.318C58.891 60.318 51.5681 26.948 63.5641 26.116C75.5591 25.282 73.026 58.684 73.026 58.684Z",
    fill: "#F3DBBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.669 58.373C82.669 58.373 83.6259 88.4301 89.0209 89.0541C94.4179 89.6771 102.21 60.6321 102.21 60.6321C102.21 60.6321 112.631 21.611 95.765 20.439C78.9 19.268 82.669 58.373 82.669 58.373Z",
    fill: "#8A603C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3709 58.684C85.3709 58.684 86.0629 80.426 89.9669 80.876C93.8709 81.327 99.5059 60.318 99.5059 60.318C99.5059 60.318 106.829 26.948 94.8339 26.116C82.8379 25.282 85.3709 58.684 85.3709 58.684Z",
    fill: "#F3DBBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.407 106.642C113.373 114.369 116.814 134.263 78.033 134.263C39.25 134.263 45.872 113.448 49.184 106.459C47.797 83.956 60.94 66.607 79.223 66.607C97.508 66.607 109.145 83.493 108.407 106.642Z",
    fill: "#966A4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.14 93.159C84.14 96.638 86.961 99.4601 90.441 99.4601C93.92 99.4601 96.741 96.639 96.741 93.159C96.741 89.679 93.92 86.859 90.441 86.859C86.961 86.86 84.14 89.68 84.14 93.159Z",
    fill: "#F3DBBD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.437 93.2101C86.437 95.2801 88.116 96.958 90.186 96.958C92.254 96.958 93.932 95.2801 93.932 93.2101C93.932 91.1401 92.254 89.463 90.186 89.463C88.115 89.463 86.437 91.1401 86.437 93.2101Z",
    fill: "#3D342F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6489 90.118C89.6489 91.103 90.45 91.902 91.434 91.902C92.42 91.902 93.2189 91.103 93.2189 90.118C93.2189 89.132 92.42 88.333 91.434 88.333C90.449 88.332 89.6489 89.131 89.6489 90.118Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.074 92.791C75.074 96.27 72.255 99.091 68.774 99.091C65.295 99.091 62.475 96.271 62.475 92.791C62.475 89.312 65.295 86.492 68.774 86.492C72.255 86.493 75.074 89.313 75.074 92.791Z",
    fill: "#F3DBBD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.859 93.2101C71.859 95.2801 70.181 96.958 68.111 96.958C66.042 96.958 64.365 95.2801 64.365 93.2101C64.365 91.1401 66.042 89.463 68.111 89.463C70.181 89.463 71.859 91.1401 71.859 93.2101Z",
    fill: "#3D342F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.647 90.118C68.647 91.103 67.847 91.902 66.862 91.902C65.876 91.902 65.077 91.103 65.077 90.118C65.077 89.132 65.876 88.333 66.862 88.333C67.847 88.332 68.647 89.131 68.647 90.118Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_979",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 66,
    width: 66,
    height: 69
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.407 106.642C113.373 114.369 116.814 134.263 78.033 134.263C39.25 134.263 45.872 113.448 49.184 106.459C47.797 83.956 60.94 66.607 79.223 66.607C97.508 66.607 109.145 83.493 108.407 106.642Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.8809 104.805C90.3409 104.805 84.1949 106.496 78.8569 109.464C73.5179 106.496 67.3739 104.805 60.8329 104.805C40.3119 104.805 23.6799 118.862 23.6799 139.382C23.6799 159.902 40.3129 176.536 60.8329 176.536C67.3739 176.536 73.5179 174.843 78.8569 171.876C84.1959 174.843 90.3409 176.536 96.8809 176.536C117.4 176.536 134.034 159.901 134.034 139.382C134.034 118.862 117.401 104.805 96.8809 104.805Z",
    fill: "#F3DBBD"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.459 109.407C86.459 111.784 81.391 115.488 79.363 115.488C77.336 115.488 71.254 111.784 71.254 109.407C71.254 107.027 74.658 105.097 78.857 105.097C83.055 105.097 86.459 107.027 86.459 109.407Z",
    fill: "#3D342F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.517 124.131C69.551 124.131 67.37 123.159 65.012 121.231C64.697 120.972 64.652 120.509 64.907 120.194C65.164 119.881 65.628 119.835 65.943 120.091C68.701 122.349 71.079 123.121 73.006 122.389C76.846 120.929 77.983 114.057 77.993 113.988C78.057 113.587 78.432 113.311 78.836 113.377C79.237 113.441 79.511 113.817 79.447 114.219C79.396 114.537 78.156 122.004 73.528 123.765C72.886 124.01 72.216 124.131 71.517 124.131Z",
    fill: "#3D342F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1759 124.775C84.5689 124.775 83.9859 124.665 83.4289 124.441C79.0289 122.68 78.2049 114.52 78.1719 114.174C78.1329 113.769 78.4289 113.411 78.8329 113.372C79.2369 113.33 79.5979 113.629 79.6369 114.033C79.8389 116.147 81.0149 121.891 83.9769 123.076C85.6019 123.727 87.6729 122.974 90.1319 120.841C90.4399 120.576 90.9029 120.608 91.1689 120.914C91.4359 121.221 91.4039 121.687 91.0959 121.953C88.9309 123.831 86.9459 124.775 85.1759 124.775Z",
    fill: "#3D342F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.595 114.184C95.595 114.184 101.603 108.299 119.258 105.6",
    stroke: "#3D342F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.611 116.451C96.611 116.451 103.911 112.273 121.677 114.125",
    stroke: "#3D342F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9139 119.251C96.9139 119.251 104.965 116.818 121.862 122.605",
    stroke: "#3D342F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.082 113.448C59.082 113.448 53.074 107.562 35.418 104.867",
    stroke: "#3D342F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.066 115.714C58.066 115.714 50.766 111.537 33.001 113.389",
    stroke: "#3D342F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.762 118.514C57.762 118.514 49.711 116.083 32.813 121.87",
    stroke: "#3D342F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.84538e045c893ce8533026cdcff614aa.svg";
export { ForwardRef as ReactComponent };